export default {"src":"/pro/_next/static/media/blast-gold-icon.6361d437.svg","height":14,"width":22,"blurWidth":0,"blurHeight":0};